import type { IMainStore } from '~/modules/main'

export const state = (): IMainStore => {
  return {
    needShowSplash: false,
    allRoulettePrizes: [],
    croppedRoulettePrizes: [],
    roulettePrice: 0,
    // TODO: Пока не используется
    gameConfiguration: {
      dailyRewards: [],
      offerLink: '',
    },
  }
}
